function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IagrofyLogoFull2 = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "126",
    height: "31",
    viewBox: "0 0 126 31",
    notChangeable: true,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.1099 0.834717H0V26.1994H25.1099V0.834717Z",
    fill: "#63A105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7442 3.25928H2.35291V4.94507H22.7442V3.25928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7442 7.02075H2.35291V8.70654H22.7442V7.02075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7442 14.5671H2.35291V16.2529H22.7442V14.5671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7743 18.3286H2.35291V20.0144H10.7743V18.3286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7572 18.3286H14.3358V20.0144H22.7572V18.3286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7743 10.7922H2.35291V12.478H10.7743V10.7922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7572 10.7922H14.3358V12.478H22.7572V10.7922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7743 22.1001H2.35291V23.7859H10.7743V22.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7572 22.1001H14.3358V23.7859H22.7572V22.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3241 3.09302H42.1712L49.9497 23.6208H45.7583L44.2155 19.51H35.0869L33.5184 23.6208H29.3141L37.3241 3.09302ZM36.1412 16.3719H43.174L39.7412 7.28156L36.1412 16.3719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2581 7.39648C91.1052 7.39648 94.5895 10.9626 94.5895 15.7606C94.5895 20.4938 91.1052 24.034 86.2581 24.034C81.4624 24.034 77.9781 20.5068 77.9781 15.7606C77.9781 10.9496 81.4624 7.39648 86.2581 7.39648ZM86.2581 20.1566C88.8553 20.1566 90.6038 18.2245 90.6038 15.7476C90.6038 13.206 88.8681 11.2479 86.2581 11.2479C83.7124 11.2479 81.9638 13.206 81.9638 15.7476C81.9638 18.2245 83.7124 20.1566 86.2581 20.1566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.014 5.65726C104.991 5.65726 105.994 6.08519 106.611 6.50015V2.46722C105.776 2.18193 104.683 1.93555 103.538 1.93555C99.8098 1.93555 98.2156 4.50314 98.2156 7.55053V8.63981H95.3741V11.9336H98.2284V23.6823H102.368V11.9336H107.01V8.63981H102.368V7.57647C102.368 6.38344 102.831 5.65726 104.014 5.65726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0985 7.62939C74.6485 7.62939 74.237 7.68126 73.8642 7.77204H73.8513C73.7099 7.79797 72.2828 8.1481 71.4213 8.90022V7.79797H67.2556V23.6833H71.4213V17.1736C71.4213 17.1736 71.4213 17.1736 71.4342 17.1736V15.2284C71.4342 12.8683 72.437 11.5197 74.4556 11.5197C75.7799 11.5197 76.8985 11.9476 77.2327 12.2718V8.05733C76.7185 7.82391 75.9599 7.62939 75.0985 7.62939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.384 8.6272L117.656 18.8976L113.053 8.6272H108.489L115.676 23.6826L115.174 24.9664C114.583 26.341 113.966 27.0153 112.616 27.0153C110.816 27.0023 110.404 26.4188 109.941 25.9649V30.0108C110.687 30.348 111.639 30.6073 112.616 30.6073C116.061 30.6073 118.041 28.7919 119.571 24.7978L126 8.6272H121.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.508 7.82455V9.4455C60.4794 8.40809 58.9494 7.78564 56.8794 7.78564C52.5852 7.78564 49.6666 11.3258 49.6666 15.67C49.6666 19.9623 52.5852 23.4894 56.8794 23.4894C58.8594 23.4894 60.4151 22.8281 61.508 21.8296V23.3079C61.508 26.0311 59.7337 26.9907 57.7923 26.9907C55.5037 26.9907 54.2566 26.6146 53.2152 25.9792V29.8306C54.3209 30.3234 55.6066 30.6346 57.7409 30.6346C62.3951 30.6346 65.6351 27.8725 65.6351 22.4002V7.82455H61.508ZM61.508 18.1857C60.7109 19.0286 59.4123 19.6899 58.0366 19.6899C55.5037 19.6899 53.8838 18.0301 53.8838 15.6829C53.8838 13.3099 55.478 11.6111 58.0366 11.6111C59.4509 11.6111 60.8009 12.3632 61.508 13.1413V18.1857Z",
    fill: "white"
  }));
});